export const KLOKKESLETTPRIORITERING_INTRODUCTION_DATE = new Date(2024, 2, 1);
export const BRSYS_CONVERSION_DATE = new Date(2023, 10, 2);
